import React from 'react';
import { IndependenceDay5to122026 } from '../views';

const SchoolProgrampage = () => {
  return <IndependenceDay5to122026 />;
};

export default SchoolProgrampage;